// This service uses the supplier filter API call to populate a map of the form:
// { supplierNdx1: supplierName1, supplierNdx2: supplierName2, ...}

(function () {
	'use strict';
	angular.module('app.supplyChain')
		.service('supplierListService', supplierListService);

	supplierListService.$inject = ['$http', 'URLS'];
	function supplierListService($http, URLS) {
		var supplierList = {};
		var loaded = false;

		return {
			getSupplierList: getSupplierList,
			loadSupplierList: loadSupplierList,
			isLoaded: isLoaded
		};

		function isLoaded() {
			return loaded;
		}

		function getSupplierList() {
			return supplierList;
		}

		function loadSupplierList(includeInactive) {
			return $http.get(URLS.host + String.format(URLS.suppliers, 'LDNA_A_S') + '?grouped=false')
				.then(loadSupplierListSuccess)
				.catch(loadSupplierListFailure);
			
			function loadSupplierListSuccess(response) {
				if (response) {
					var suppliersInResponse = response['data'];
					if (suppliersInResponse) {
						angular.forEach(suppliersInResponse, function (supplierObject) {
							supplierList[supplierObject['supplierNdx']] = supplierObject['supplierName'];
						});
					}
				}
				loaded = true;
			}

			function loadSupplierListFailure(error) {
				supplierList = {};
			}
		}
	}
})();
